import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@ubisend/pulse-components';

const SmallTalk = ({ content }) => {
  return (
    <Button variant="inline" as={Link} to={`/smalltalk/${content.id}`}>
      {content.name}
    </Button>
  );
};

SmallTalk.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default SmallTalk;
